export const formatPhoneNumber = (phone_number: string): string | null => {
  // Remove any non-digit except plus
  let cleaned = phone_number.replace(/[^\d+]/g, '');

  if (cleaned.startsWith('+1')) {
    // Already correct format, keep as is
  } else if (cleaned.startsWith('1')) {
    // Starts with 1 but no plus, add plus
    cleaned = '+' + cleaned;
  } else {
    // Otherwise, add +1 prefix
    // Remove any leading pluses if any
    cleaned = cleaned.replace(/^\+*/, '');
    cleaned = '+1' + cleaned;
  }

  // Validate US format: +1 followed by exactly 10 digits
  const phoneRegex = /^\+1\d{10}$/;
  if (!phoneRegex.test(cleaned)) {
    return null;
  }

  return cleaned;
};

export const formatEmail = (email: string): string | null => {
    // Trim whitespace and convert to lowercase
    const trimmed = email.trim().toLowerCase();

    // Basic email regex for validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(trimmed)) {
        return null; // Invalid email format
    }

    return trimmed;
};

// Modify formatDate to handle both string and Date types
export const formatDate = (date: string | Date): string => {
    // If the date is a string, convert it to a Date object
    const dateObj = typeof date === 'string' ? new Date(date) : date;

    // Check if the date is valid
    if (isNaN(dateObj.getTime())) {
        return 'Invalid Date';
    }

    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    };
    return dateObj.toLocaleDateString(undefined, options);
};


export const prettyDateTime = (date: string | Date): string => {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    // Check if the date is valid
    if (isNaN(dateObj.getTime())) {
        return 'Invalid Date';
    }

    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    };
    return dateObj.toLocaleString(undefined, options);
}

// export const formatDateForBackend = (date: string | Date): string => {
//   console.log(date);
//   const dateObj = typeof date === 'string' ? new Date(date) : date;
//   if (isNaN(dateObj.getTime())) {
//     throw new Error('Invalid date');
//   }

//   const pad = (n: number) => n.toString().padStart(2, '0');

//   // Format: "YYYY-MM-DD HH:mm:ss"
//   return `${dateObj.getFullYear()}-${pad(dateObj.getMonth() + 1)}-${pad(dateObj.getDate())} ${pad(dateObj.getHours())}:${pad(dateObj.getMinutes())}:${pad(dateObj.getSeconds())}`;
// };

export const formatDateForBackend = (input: string | Date): string => {
  let dateObj: Date;
  
  if (input instanceof Date) {
    // Input is already a Date object
    if (isNaN(input.getTime())) {
      throw new Error('Invalid Date object');
    }
    dateObj = input;
  } else if (typeof input === 'string') {
    // Check if string has timezone info (Z or offset)
    const hasTimezone = /([Zz]|[+\-]\d{2}:\d{2})$/.test(input);

    if (hasTimezone) {
      dateObj = new Date(input);
    } else {
      // Local time string without timezone info
      // Add seconds if missing (e.g., "2024-11-11T08:00" -> "2024-11-11T08:00:00")
      let fixedInput = input;
      if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(input)) {
        fixedInput = `${input}:00`;
      }
      dateObj = new Date(fixedInput);
    }

    if (isNaN(dateObj.getTime())) {
      throw new Error('Invalid date string');
    }
  } else {
    throw new Error('Input must be a string or Date');
  }

  // Format to UTC ISO string without milliseconds
  const pad = (n: number) => n.toString().padStart(2, '0');

  return `${dateObj.getUTCFullYear()}-${pad(dateObj.getUTCMonth() + 1)}-${pad(dateObj.getUTCDate())}T${pad(dateObj.getUTCHours())}:${pad(dateObj.getUTCMinutes())}:${pad(dateObj.getUTCSeconds())}Z`;
};

export const formatDateForBackendCreate = (input: string | Date): string => {
  let date: Date;

  if (typeof input === 'string') {
    date = new Date(input);
  } else if (input instanceof Date) {
    date = input;
  } else {
    throw new Error('Input must be string or Date');
  }

  if (isNaN(date.getTime())) {
    throw new Error('Invalid date');
  }

  return date.toISOString().replace(/\.\d{3}Z$/, 'Z');
};



// export const formatDateForBackend = (date: string | Date): string => {
//   let dateObj: Date;

//   if (typeof date === 'string') {
//     // Strip the trailing Z so it will parse as local time, not UTC
//     // Also remove milliseconds if present
//     const localDateString = date.replace(/\.?\d*Z$/, '');

//     // Parse as local date/time (no timezone info)
//     dateObj = new Date(localDateString);
//   } else {
//     dateObj = date;
//   }

//   if (isNaN(dateObj.getTime())) {
//     throw new Error('Invalid date');
//   }

//   const pad = (n: number) => n.toString().padStart(2, '0');

//   // Format as "YYYY-MM-DD HH:mm:ss"
//   // This is local time in your machine
//   const formattedLocal = `${dateObj.getFullYear()}-${pad(dateObj.getMonth() + 1)}-${pad(dateObj.getDate())} ${pad(dateObj.getHours())}:${pad(dateObj.getMinutes())}:${pad(dateObj.getSeconds())}`;

//   return formattedLocal;
// };




export const prettyFormattedPhoneNumber = (phoneNumber: string): string => {
    const digits = phoneNumber.replace(/\D/g, '');

  // Must be 11 digits and start with '1' (for US country code)
  if (digits.length !== 11 || !digits.startsWith('1')) {
    return phoneNumber; // Return as-is if not a valid US phone number
  }

  const country = digits[0];              // '1'
  const area = digits.slice(1, 4);        // Area code
  const central = digits.slice(4, 7);     // Central office code
  const line = digits.slice(7, 11);       // Line number

  return `+${country} (${area}) ${central}-${line}`;
}